/**
 * Get the image dimensions for the image that is being uploaded. We are not doing this on the
 * server because it no longer has access to the actual image file itself, so we'll have to
 * pass these values to the API.
 *
 * @param {string} imageDataURL  The base 64 data URL containing the image data.
 */
export const getImageDimensionsFromDataURL = (imageDataURL: string) =>
  new Promise<{
    width: number;
    height: number;
  }>((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      const dimensions = {
        width: image.width,
        height: image.height,
      };

      image.remove();

      resolve(dimensions);
    };

    image.onerror = (error) => reject(error);

    image.src = imageDataURL;
  });
